export const storeCompanyList = (state, companyList) => {
  state.companyList = [...companyList];
};
export const storeCompanyFilterList = (state, companyList) => {
  state.companyFilterList = [...companyList];
};

export const storeCompany = (state, company) => {
  state.company = { ...company };
};
